import { memo } from 'react';
import ProductCardSkeleton from '@/components/reusable/productCard/productCardSkeleton/ProductCardSkeleton';
import styles from './CardsSkeleton.module.scss';
import Box from '@/components/UI/box/Box';
import useDevice from '@/hooks/useDevice';
import ProductCard from '@/components/reusable/productCard/ProductCard';
const CardsSkeleton = ({
  firstData
}) => {
  const {
    isMobile
  } = useDevice();
  return <Box className={styles.container} data-sentry-element="Box" data-sentry-component="CardsSkeleton" data-sentry-source-file="CardsSkeleton.tsx">
      {firstData && <Box className={`${styles.product_skeleton_card_container}`}>
          <ProductCard key={firstData?.id} data={firstData?.list?.[0]} isShowMap={false} index={0} isCarousel={true} isFirstCard={true} />
        </Box>}

      {Array.from({
      length: isMobile ? 1 : 7
    }).map((_, index) => <Box key={`PRODUCT_CARD_SKELETON_${index}`} className={`${styles.product_skeleton_card_container}`}>
          <ProductCardSkeleton />
        </Box>)}
    </Box>;
};
export default memo(CardsSkeleton);